import { Component, Prop, Vue, Ref, Watch } from 'vue-property-decorator';
import { Strategy } from '@/classes/Strategy';
import {Chart} from 'highcharts-vue'
import { StrategyResults } from '@/classes/StrategyResults';

@Component({
  name: 'strategy-card',
  components: {
    Chart
  },
})
export default class strategyCard extends Vue {

  @Prop()
  public strategy!: Strategy;

  @Prop()
  public result!: StrategyResults;

  @Prop()
  public type!: string;

  @Ref()
  public canvas!: HTMLCanvasElement;

  @Watch('strategy', {deep: true})
  onStrategyChanged(oldVal: Strategy, newVal: Strategy) {
    // this.strategy = newVal;
    // this.onDraw();
  }

  get chartOptions() {
    let opts = {series: [{data: this.result.history}],
                title: {text: this.strategy.name + ' ' + this.strategy.interval},
                legend: {enabled: false},
                yAxis: {title: {text: 'Portfolio Value'}},
                xAxis: {title: {text: this.strategy.interval}}};
    return opts;
  }

  mounted() {
    // this.onDraw()
  }

  // onDraw() {
  //   if ( this.typeHistory != undefined) {
  //     const minPoint = Math.min(...this.typeHistory);
  //     const maxPoint = Math.max(...this.typeHistory);
  //     const range = maxPoint - minPoint;
  //
  //
  //
  //     const widthPerPoint = this.canvas.width / (this.typeHistory.length - 1);
  //     const heightPerPoint = this.canvas.height / range;
  //
  //
  //     const getHeight = (point: number) => (range - (point - minPoint)) * heightPerPoint;
  //     const ctx = this.canvas.getContext("2d")!;
  //     ctx.beginPath();
  //     for (let i = 0; i < this.typeHistory.length-1; i++) {
  //       ctx.moveTo(i * widthPerPoint, getHeight(this.typeHistory[i]));
  //       ctx.lineTo((i+1) * widthPerPoint, getHeight(this.typeHistory[i+1]));
  //       ctx.stroke();
  //
  //       ctx.moveTo(i * widthPerPoint, range * heightPerPoint)
  //       ctx.lineTo(i * widthPerPoint, range * heightPerPoint - 7)
  //       ctx.stroke();
  //
  //       ctx.fillText(i.toString(), i * widthPerPoint + 5, range * heightPerPoint - 5);
  //     }
  //
  //     const vertTicks = 5;
  //     const heightBetweenTicks = this.canvas.height / vertTicks
  //     for (let i = 0; i < vertTicks; i++) {
  //       ctx.moveTo(0, i * heightBetweenTicks)
  //       ctx.lineTo(7, i * heightBetweenTicks)
  //       ctx.stroke();
  //
  //       ctx.fillText('$' + ((vertTicks - i) * range/vertTicks + minPoint).toString(), 5, i * heightBetweenTicks - 5);
  //     }
  //   }
  // }

  onClick() {
    this.$emit('strategyClicked', this.strategy)
  }
}
